import React from 'react'
import { formatMoney } from '@ztechapps/common.utils'
import { PricePerUom } from '@ztechapps/product.webui'
import { HorizontalStack } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'

type AtPricePerUomProps = { price: number; uom: string }
export const AtPricePerUom = ({ price, uom }: AtPricePerUomProps) => (
  <HorizontalStack>
    <small className="text-muted pe-1">@</small>
    <PricePerUom price={price} uom={uom} />
  </HorizontalStack>
)

export const OrderPriceWrap = ({ price, net, uom }: { price: number; net: number; uom?: string }) => (
  <Stack>
    <div className="price">{formatMoney(net)} </div>
    <AtPricePerUom price={price} uom={uom} />
  </Stack>
)
